import React, { Component } from 'react'
import { PropagateLoader } from 'react-spinners'
import '../style.css'

export default class Loading extends Component {

  render(){
    return (
      <div className="LoadingContato">
        <PropagateLoader
          size={20}
          color={'#58b711'}
        />
      </div>
    )
  }
}